import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown'


const MarkDown = (props) => {
    const [getMark, setMarkdown] = useState("");
    useEffect(() => {
        if (typeof props.markdownValue == "string") {
            setMarkdown(props.markdownValue)
        } else {
            var newArray = props.markdownValue.length !== 0 ? props.markdownValue.join('') : props.markdownValue;
            setMarkdown(newArray)
        }
    }, [props]);
    return <div >
        <ReactMarkdown >{getMark}</ReactMarkdown>
    </div>
}
export default MarkDown;